import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import { Breadcrumbs } from '@platform/navigation';
import { Spinner } from '@platform/ui';
import type { INewRecordNavState } from './INewRecordNavState';
import type { INewRecordPageProps } from './INewRecordPageProps';
import { NewRecordDraft } from './NewRecordDraft';
import { useNewRecordCrumbs } from './useNewRecordCrumbs';
import { useNextCode } from './useNextCode';

/**
 * Сторінка нового запису (…/<сутність>/new): крихти «… › Модуль › Завдання 212» (прототип v4: чернетка вже має номер; не вдалося
 * дізнатися — «Завдання (новий запис)») і чернетка; стан переходу (наперед задані значення, звідки прийшли) читається один раз —
 * перемикання вкладок його не губить.
 */
export function NewRecordPage({ ws, moduleKey, rtKey, module, rt }: INewRecordPageProps) {
  const { t } = useTranslation();
  const strings = useModuleStrings();
  const { state } = useLocation();
  const [nav] = useState<INewRecordNavState>(() => (state as INewRecordNavState | null) ?? {});
  const singular = rt ? strings.entity(rt.key, 'singular', rt.singular ?? rt.name) : '';
  const code = useNextCode(ws, rtKey);
  const crumbs = useNewRecordCrumbs(ws, moduleKey, rtKey, code ? `${singular} ${code}` : t('recordPage.draft.crumb', { type: singular }));
  return (
    <>
      <div className="rec__crumbs"><Breadcrumbs items={crumbs} /></div>
      {module && rt ? <NewRecordDraft ws={ws} module={module} rt={rt} nav={nav} /> : <div className="rec__state"><Spinner /></div>}
    </>
  );
}
